import { useQuery } from "@tanstack/react-query";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const useDisciplines = () => {
  return useQuery({
    queryKey: ["disciplines"],
    queryFn: async () => {
      return (await getDoc(doc(db, "Consts", "disciplines"))).data();
    },
  });
};

export default useDisciplines;
